/**
 * Glossy Button Active State Detection
 * Detects if glossy buttons link to the current page and applies active styles
 */
function initGlossyButtons() {
  const glossyButtons = document.querySelectorAll('[data-glossy-button]');
  const currentPath = window.location.pathname;
  const currentUrl = window.location.href;

  console.log('initGlossyButtons');
  console.log(glossyButtons);
  console.log(currentPath);
  console.log(currentUrl);
  
  glossyButtons.forEach(buttonWrap => {
    const link = buttonWrap.querySelector('.glossy-button');
    
    if (!link || !link.href) return;
    
    // Get the link's path for comparison
    let linkPath;
    try {
      const linkUrl = new URL(link.href);
      linkPath = linkUrl.pathname;
    } catch (e) {
      // If URL parsing fails, try direct comparison
      linkPath = link.getAttribute('href');
    }
    
    // Check if current page matches the button link
    const isActive = (
      linkPath === currentPath || 
      link.href === currentUrl ||
      (linkPath === '/' && currentPath === '/') ||
      (linkPath && currentPath.startsWith(linkPath) && linkPath !== '/')
    );
    
    // Apply active classes if link matches current page
    if (isActive) {
      buttonWrap.classList.add('glossy-active');
      link.classList.add('glossy-button-active');
    } else {
      buttonWrap.classList.remove('glossy-active');
      link.classList.remove('glossy-button-active');
    }
  });
}

// Initialize on DOM ready
document.addEventListener('DOMContentLoaded', initGlossyButtons);

// Re-initialize on page changes (for SPAs or dynamic content)
document.addEventListener('shopify:section:load', initGlossyButtons);

// For theme editor live updates
document.addEventListener('shopify:block:load', initGlossyButtons);

// Optional: Re-check on popstate (browser back/forward)
window.addEventListener('popstate', initGlossyButtons);

/**
 * Image Carousel using Splide
 * Initializes carousel with responsive settings
 */
function initImageCarousels() {
  const carousels = document.querySelectorAll('.image-carousel');
  
  carousels.forEach(carousel => {
    // Get settings from data attributes
    const perPageDesktop = parseInt(carousel.dataset.perPageDesktop) || 4;
    const perPageMobile = parseInt(carousel.dataset.perPageMobile) || 1;
    const arrowsDesktop = carousel.dataset.arrowsDesktop === 'true';
    const arrowsMobile = carousel.dataset.arrowsMobile === 'true';
    const dotsDesktop = carousel.dataset.dotsDesktop === 'true';
    const dotsMobile = carousel.dataset.dotsMobile === 'true';
    const gap = parseInt(carousel.dataset.gap) || 20;
    
    // Check if Splide is available
    if (typeof Splide === 'undefined') {
      console.warn('Splide library not loaded');
      return;
    }
    
    // Initialize Splide
    const splide = new Splide(carousel, {
      type: 'loop',
      gap: gap + 'px',
      perPage: perPageDesktop,
      perMove: 1,
      pagination: dotsDesktop,
      arrows: arrowsDesktop,
      autoplay: false,
      pauseOnHover: true,
      resetProgress: false,
      fixedWidth: false,
      autoWidth: true,
      focus: 0,
      trimSpace: true,
      start: 0,
      breakpoints: {
        749: {
          perPage: perPageMobile,
          pagination: dotsMobile,
          arrows: arrowsMobile,
          autoWidth: true,
        }
      }
    });
    
    // Mount the carousel
    try {
      splide.mount();
      
      // Ensure carousel starts at the first slide after mounting
      setTimeout(() => {
        if (splide && splide.go) {
          splide.go(0);
        }
      }, 50);
      
    } catch (error) {
      console.error('Error mounting Splide carousel:', error);
    }
  });
}

// Initialize carousels when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Wait a bit for Splide to load if it's deferred
  setTimeout(initImageCarousels, 100);
});

// Re-initialize on Shopify section loads (theme editor)
document.addEventListener('shopify:section:load', function(event) {
  if (event.target.querySelector('.image-carousel')) {
    setTimeout(initImageCarousels, 100);
  }
});

// Initialize on block loads (theme editor)
document.addEventListener('shopify:block:load', function(event) {
  if (event.target.closest('.image-carousel')) {
    setTimeout(initImageCarousels, 100);
  }
});

(function analisarAccordionsVazios() {
    const accordionContents = document.querySelectorAll('.accordion-custom .details-content');    
    accordionContents.forEach(content => {
        if (content.textContent.trim() === '') {
            content.classList.add('is-empty');
        } else {
            content.classList.remove('is-empty');
        }
    });
})();


/* Padronizar altura de product-subtitle */
function padronizarAlturaDasSecoes() {
  const secoes = document.querySelectorAll('.section');
  secoes.forEach(secao => {
    const subtitulos = secao.querySelectorAll('.product-subtitle');
    let alturaMaxima = 0;
    subtitulos.forEach(subtitulo => {
      const altura = subtitulo.offsetHeight;
      if (altura > alturaMaxima) {
        alturaMaxima = altura;
      }
    });
    subtitulos.forEach(subtitulo => {
      subtitulo.style.height = alturaMaxima + 'px';
    });
  });
}

document.addEventListener('DOMContentLoaded', padronizarAlturaDasSecoes);
document.addEventListener('shopify:section:load', padronizarAlturaDasSecoes);

/**
 * Gift Selector Management
 * Gerencia a seleção de brindes e adiciona ao carrinho
 */
(function() {
  'use strict';

  // Configuração
  const GIFT_PROPERTY_KEY = '_gift_for_item';
  const PARENT_PROPERTY_KEY = '_parent_item_key';
  
  /**
   * Inicializa o seletor de brindes
   */
  function initGiftSelector() {
    const giftSelector = document.querySelector('[data-gift-selector]');
    if (!giftSelector) return;

    const giftRadios = giftSelector.querySelectorAll('input[type="radio"][name="gift-selection"]');
    const selectedGiftDataInput = giftSelector.querySelector('[data-selected-gift-data]');

    // Listener para mudanças na seleção
    giftRadios.forEach(radio => {
      radio.addEventListener('change', function() {
        if (this.checked) {
          const giftData = {
            id: this.dataset.giftId,
            variantId: this.dataset.giftVariant,
            title: this.dataset.giftTitle,
            image: this.dataset.giftImage,
            price: this.dataset.giftPrice
          };
          selectedGiftDataInput.value = JSON.stringify(giftData);
          console.log('Brinde selecionado:', giftData);
        }
      });
    });
  }

  /**
   * Intercepta o adicionar ao carrinho para incluir o brinde
   */
  function interceptAddToCart() {
    const productForm = document.querySelector('form[action*="/cart/add"]');
    if (!productForm) return;

    // productForm.addEventListener('submit', async function(e) {
    productForm.querySelector('.button.add-to-cart-button').addEventListener('click', async function(e) {
      console.log('add-to-cart-button clicked');
      
      const giftSelector = document.querySelector('[data-gift-selector]');
      if (!giftSelector) return; // Sem seletor de brinde nesta página

      const selectedGiftDataInput = giftSelector.querySelector('[data-selected-gift-data]');
      if (!selectedGiftDataInput || !selectedGiftDataInput.value) return; // Nenhum brinde selecionado

      e.preventDefault();
      e.stopPropagation();

      try {
        const giftData = JSON.parse(selectedGiftDataInput.value);
        const formData = new FormData(productForm);
        
        // Pega os dados do produto principal
        const mainProductVariantId = formData.get('id');
        const mainProductQuantity = parseInt(formData.get('quantity') || '1');
        
        // Cria um identificador único para este par produto-brinde
        const parentItemKey = `${mainProductVariantId}_${Date.now()}`;

        // Prepara os itens para adicionar
        const items = [
          {
            id: mainProductVariantId,
            quantity: mainProductQuantity,
            properties: {
              [GIFT_PROPERTY_KEY]: giftData.variantId,
              '_parent_item_key': parentItemKey
            }
          },
          {
            id: giftData.variantId,
            quantity: mainProductQuantity,
            properties: {
              [PARENT_PROPERTY_KEY]: parentItemKey,
              '_is_gift': 'true',
              '_gift_parent_variant': mainProductVariantId,
              '_gift_title': 'Brinde'
            }
          }
        ];

        // Adiciona ambos os itens ao carrinho
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ items })
        });

        if (!response.ok) {
          throw new Error('Erro ao adicionar ao carrinho');
        }

        const result = await response.json();
        console.log('Itens adicionados ao carrinho:', result);

        // Dispara evento de atualização do carrinho (formato do tema)
        document.dispatchEvent(new CustomEvent('cart:update', { 
          bubbles: true,
          detail: {
            resource: result,
            sourceId: 'gift-selector',
            data: {
              itemCount: result.item_count,
              source: 'gift-selector'
            }
          }
        }));
        
        // Abre o cart drawer se existir
        const cartDrawer = document.querySelector('cart-drawer-component');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }

      } catch (error) {
        console.error('Erro ao adicionar produto com brinde:', error);
        // Em caso de erro, tenta adicionar normalmente
        productForm.submit();
      }
    });
  }

  /**
   * Gerencia a remoção automática de brindes quando o produto pai é removido
   */
  async function setupGiftCartManagement() {
    // Observa mudanças no carrinho (evento correto do tema)
    document.addEventListener('cart:update', function(e) {
      console.log('🔄 Evento cart:update detectado, validando brindes...');
      setTimeout(validateGiftItems, 300);
    });
    
    // Intercepta remoções de itens através do botão de remoção
    document.addEventListener('click', async function(e) {
      const removeButton = e.target.closest('.cart-items__remove');
      if (removeButton) {
        console.log('🗑️ Botão de remoção clicado, validando brindes...');
        // Pequeno delay para garantir que o item foi removido antes de validar
        setTimeout(validateGiftItems, 600);
      }
    });

    // Observa mudanças através do FormData quando a quantidade é alterada
    const cartForm = document.querySelector('#cart-form');
    if (cartForm) {
      cartForm.addEventListener('change', async function(e) {
        if (e.target.name === 'updates[]' && e.target.value === '0') {
          console.log('📝 Quantidade alterada para 0, validando brindes...');
          setTimeout(validateGiftItems, 600);
        }
      });
    }
  }

  /**
   * Valida e remove brindes órfãos (sem produto pai)
   */
  async function validateGiftItems() {
    try {
      let cart = await (await fetch('/cart.js')).json();
      
      if (!cart.items || cart.items.length === 0) return;

      console.log('🔍 Validando brindes no carrinho...');

      // Identifica produtos pai
      const parentKeys = new Set();
      cart.items.forEach((item) => {
        if (item.properties && item.properties._parent_item_key && item.properties._is_gift !== 'true') {
          parentKeys.add(item.properties._parent_item_key);
          console.log('✅ Produto pai:', item.product_title, 'Key:', item.properties._parent_item_key);
        }
      });

      // Identifica e remove brindes órfãos um por vez
      let removedCount = 0;
      let maxAttempts = 10; // Previne loop infinito
      let attempts = 0;
      
      while (attempts < maxAttempts) {
        attempts++;
        
        // Busca carrinho atualizado a cada iteração
        cart = await (await fetch('/cart.js')).json();
        
        // Procura o primeiro brinde órfão
        let orphanGiftIndex = -1;
        let orphanGift = null;
        
        for (let i = 0; i < cart.items.length; i++) {
          const item = cart.items[i];
          if (item.properties && item.properties._is_gift === 'true') {
            const parentKey = item.properties[PARENT_PROPERTY_KEY];
            const hasPai = parentKeys.has(parentKey);
            
            console.log('🎁 Brinde:', item.product_title, 'Parent Key:', parentKey, 'Tem pai?', hasPai);
            
            if (parentKey && !hasPai) {
              orphanGiftIndex = i + 1; // API usa índice baseado em 1
              orphanGift = {
                title: item.product_title,
                parentKey: parentKey,
                line: orphanGiftIndex
              };
              break;
            }
          }
        }
        
        // Se não encontrou mais brindes órfãos, para
        if (orphanGiftIndex === -1) {
          break;
        }
        
        // Remove o brinde encontrado
        console.log('🗑️ Removendo brinde órfão:', orphanGift.title, 'linha:', orphanGift.line);
        
        try {
          const changeResponse = await fetch('/cart/change.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              line: orphanGiftIndex,
              quantity: 0
            })
          });

          if (changeResponse.ok) {
            removedCount++;
            console.log('✅ Brinde removido:', orphanGift.title);
            await new Promise(resolve => setTimeout(resolve, 150));
          } else {
            const errorData = await changeResponse.json().catch(() => ({ error: 'Unknown error' }));
            console.error('❌ Erro ao remover brinde:', orphanGift.title, errorData);
            break; // Para se houver erro
          }
        } catch (error) {
          console.error('❌ Exceção ao remover brinde:', orphanGift.title, error);
          break;
        }
      }
      
      if (removedCount > 0) {
        console.log('✅ Total de brindes removidos:', removedCount);
        
        // Busca carrinho final
        const finalCart = await (await fetch('/cart.js')).json();
        
        // Dispara evento de atualização do carrinho
        document.dispatchEvent(new CustomEvent('cart:update', { 
          bubbles: true,
          detail: {
            resource: finalCart,
            sourceId: 'gift-validator',
            data: {
              itemCount: finalCart.item_count,
              source: 'gift-validator'
            }
          }
        }));
        
        // Recarrega a página do carrinho se estiver nela
        if (window.location.pathname.includes('/cart')) {
          setTimeout(() => window.location.reload(), 400);
        }
      } else {
        console.log('✅ Nenhum brinde órfão encontrado');
      }
    } catch (error) {
      console.error('❌ Erro ao validar brindes:', error);
    }
  }

  /**
   * Previne alteração de quantidade de brindes
   */
  function preventGiftQuantityChange() {
    const cartElements = document.querySelectorAll('cart-drawer-component, cart-items-component');
    if (cartElements.length === 0) return;

    cartElements.forEach(cartElement => {
      // Observa mudanças no DOM do carrinho
      const observer = new MutationObserver(() => {
        disableGiftQuantityInputs();
      });

      observer.observe(cartElement, {
        childList: true,
        subtree: true
      });
    });

    // Executa na inicialização
    disableGiftQuantityInputs();
  }

  /**
   * Desabilita inputs de quantidade para brindes
   */
  function disableGiftQuantityInputs() {
    const cartItems = document.querySelectorAll('[data-cart-item]');
    
    cartItems.forEach(cartItem => {
      // Verifica se é um brinde através do data attribute
      const isGift = cartItem.dataset.isGift === 'true';
      
      if (isGift) {
        console.log('🎁 Processando brinde:', cartItem);
        
        // Encontra o componente quantity-selector
        const quantitySelector = cartItem.querySelector('quantity-selector-component');
        
        if (quantitySelector) {
          // Desabilita o input de quantidade
          const quantityInput = quantitySelector.querySelector('input[ref="quantityInput"]');
          if (quantityInput) {
            quantityInput.disabled = true;
            quantityInput.readOnly = true;
            quantityInput.style.opacity = '0.5';
            quantityInput.style.cursor = 'not-allowed';
            quantityInput.style.pointerEvents = 'none';
          }
          
          // Desabilita os botões de + e -
          const quantityButtons = quantitySelector.querySelectorAll('button[ref="quantityButtons[]"]');
          quantityButtons.forEach(btn => {
            btn.disabled = true;
            btn.style.opacity = '0.5';
            btn.style.cursor = 'not-allowed';
            btn.style.pointerEvents = 'none';
          });

          // Adiciona estilo ao componente inteiro
          quantitySelector.style.opacity = '0.5';
          quantitySelector.style.pointerEvents = 'none';
        }

        // Adiciona badge de brinde ao lado do título
        const titleElement = cartItem.querySelector('a.cart-items__title');
        if (titleElement && !titleElement.querySelector('.gift-badge')) {
          const badge = document.createElement('span');
          badge.className = 'gift-badge';
          badge.textContent = ' Brinde';
          badge.style.cssText = `
            display: inline-block;
            background: #d1fae5;
            color: #10b981;
            padding: 2px 8px;
            border-radius: 4px;
            margin-left: 8px;
            font-size: 11px;
            font-weight: 700;
            vertical-align: middle;
          `;
          titleElement.appendChild(badge);
        }

        // Opcional: adiciona uma classe visual ao item do carrinho
        cartItem.classList.add('cart-item--gift');
      }
    });
  }

  // Inicialização
  document.addEventListener('DOMContentLoaded', function() {
    initGiftSelector();
    interceptAddToCart();
    setupGiftCartManagement();
    preventGiftQuantityChange();
    
    // Valida brindes ao carregar a página do carrinho
    if (document.querySelector('[data-cart-item]')) {
      setTimeout(validateGiftItems, 1000);
    }
  });

  // Re-inicializa em eventos do Shopify
  document.addEventListener('shopify:section:load', function() {
    initGiftSelector();
    setTimeout(preventGiftQuantityChange, 100);
  });
  
  // Observa mudanças no carrinho (evento correto do tema)
  document.addEventListener('cart:update', function(e) {
    console.log('🔄 cart:update recebido, atualizando UI de brindes...');
    setTimeout(preventGiftQuantityChange, 200);
  });

  // Para cart drawer - quando abre ou muda
  // Usa timeout para garantir que o drawer está montado
  const cartDrawerObserver = () => {
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer) {
      const observer = new MutationObserver(() => {
        setTimeout(preventGiftQuantityChange, 200);
      });
      observer.observe(cartDrawer, { 
        childList: true, 
        subtree: true,
        attributes: true,
        attributeFilter: ['open']
      });
    }
  }
  setTimeout(cartDrawerObserver, 500);
  document.addEventListener('shopify:section:load', cartDrawerObserver);
  document.addEventListener('cart:update', cartDrawerObserver);

})();

/**
 * Ingredientes Pill Tag
 * Extrai "Ingredientes" do título e transforma em uma pill/tag visual.
 * No mobile, a pill se estende até a borda direita da viewport.
 */
function initIngredientesPill() {
  const headings = document.querySelectorAll('.text-block h1, .text-block h2, .text-block h3, .text-block h4, .text-block h5, .text-block h6');

  headings.forEach(heading => {
    if (heading.querySelector('.ingredientes-title-wrapper')) return;

    const text = heading.textContent.trim();
    const regex = /^(.+?)\s*[-–—]\s*(ingredientes)\s*$/i;
    const match = text.match(regex);

    if (!match) return;

    const titleText = match[1].trim();
    const pillText = match[2].charAt(0).toUpperCase() + match[2].slice(1).toLowerCase();

    const wrapper = document.createElement('div');
    wrapper.className = 'ingredientes-title-wrapper';

    const titleSpan = document.createElement('span');
    titleSpan.className = 'ingredientes-title-text';
    titleSpan.textContent = titleText;

    const pill = document.createElement('span');
    pill.className = 'ingredientes-pill';
    pill.textContent = pillText;

    heading.textContent = '';
    heading.appendChild(wrapper);
    wrapper.appendChild(titleSpan);
    wrapper.appendChild(pill);

    const textBlock = heading.closest('.text-block');
    if (textBlock) {
      textBlock.classList.add('has-ingredientes-pill');
    }
  });

  updateIngredientesPillOffset();
}

function updateIngredientesPillOffset() {
  const pills = document.querySelectorAll('.ingredientes-pill');
  pills.forEach(pill => {
    pill.style.removeProperty('--pill-right-extend');

    if (window.innerWidth >= 750) return;

    // Force reflow after reset
    void pill.offsetWidth;

    const rect = pill.getBoundingClientRect();
    const rightOffset = window.innerWidth - rect.right;

    if (rightOffset > 0) {
      pill.style.setProperty('--pill-right-extend', rightOffset + 15 + 'px');
    }
  });
}

document.addEventListener('DOMContentLoaded', initIngredientesPill);
document.addEventListener('shopify:section:load', initIngredientesPill);
window.addEventListener('resize', updateIngredientesPillOffset);

/* tracking de botao de estoque */
document.addEventListener('click', function(event) {
  const button = event.target.closest('button.restock-alerts-submit-button');
  if (!button) return;

  // Tenta extrair contexto útil do entorno do botão
  const form = button.closest('.restock-alerts-modal-box');
  const emailInput = form?.querySelector('.restock-alerts-email-input');

  const payload = {
    email: emailInput?.value,
    page_url: window.location.href,
    page_path: window.location.pathname,
    timestamp: new Date().toISOString()
  };
  console.log('payload:', payload);

  if (window.Shopify && window.Shopify.analytics) {
    window.Shopify.analytics.publish('restock_alert_submitted', payload);
  }
});